import imgUtil from '../img'

// 设置商品的sku相关数据
async function SetGoodsSkuInfo({ item, obj }) {
	try {
		// 生成skuInfo
		if (item.SkuList?.length) {
			const firstSkuProperties = item.SkuList[0].SellProperties
			for (let sku of firstSkuProperties) {
				obj.skuInfo.push({
					prop_id: sku.PropId,
					property_name: sku.PropName,
					values: [],
					images: []
				})
			}
			// 根据skuList组装skuInfo
			for (let sku of item.SkuList) {
				for (let i = 0; i < sku.SellProperties.length; i++) {
					const currentSku = sku.SellProperties[i]
					if (!obj.skuInfo[i].values.find(s => s?.value_name === currentSku.ValueName)) {
						obj.skuInfo[i].values.push({
							property_name: currentSku.PropName,
							value_name: currentSku.ValueName,
							old_value_name: currentSku.ValueName
						})
					}
				}
				const newSku = {
					OriginSkuId: sku.OriginSkuId,
					stock_num: sku.Stock,
					origin_stock: sku.OriginStock,
					price: sku.Price ? +(sku.Price / 100).toFixed(2) : 0,
					origin_price: sku.OriginPrice ? +(sku.OriginPrice / 100).toFixed(2) : 0,
					sell_properties: sku.SellProperties || []
				}
				for (let i = 0; i < item.SkuList[0].SellProperties.length; i++) {
					const current = newSku.sell_properties[i]
					current.value_name = current.ValueName
					current.property_name = item.SkuList[0].SellProperties[i].PropName
					delete current.ValueName
				}
				obj.skuList.push(newSku)
			}
		}
		// 如果只有一个默认的SKU, 则需要加上OriginSkuId 【服务商单品skuId不能为空】
		// if (obj.skuList?.length === 1) obj.skuList[0].OriginSkuId = '5318824030543'
		// 获取主规格图
		if (item.SpecPicMap && Object.keys(item.SpecPicMap)?.length) {
			const values = obj.skuInfo[0].values
			for (let i = 0; i < values.length; i++) {
				obj.skuInfo[0].images[i] = item.SpecPicMap[obj.skuInfo[0].property_name + '-' + values[i].value_name] || ''
			}
		}
		if (obj.skuInfo[0]?.images.length) obj.skuInfo[0].images = await imgUtil.GetFinalImageList(obj.skuInfo[0].images, '1:1')
		else {
			const values = obj.skuInfo[0].values
			for (let i = 0; i < values.length; i++) {
				obj.skuInfo[0].images[i] = {}
			}
		}
	}
	catch(error) {
		console.log('get sku error ...', error)
	} 
}

// 提交铺货之前的sku验证
function CheckSubmitSkuData(submitData) {
	if (!submitData.skuList?.length) return '至少要有一个规格!'
	let msg = ''
	for (let i = 0; i < submitData.skuInfo.length; i++) {
		const dyList = submitData.canSelectPropertyList || []
		const item = submitData.skuInfo[i]
		const findItem = dyList.find(option => option.PropertyName === item.property_name)
		if (item?.values?.length) {
			const noValue = item.values.some(sku => !sku.value_name)
			const errMsg = item.values.find(sku => sku.errMsg)?.errMsg
			if (noValue) {
				msg = `第${i + 1}级的规格【${item.property_name}】里有规格值未填写，请先填写`
				break
			}
			if (errMsg) {
				msg = `第${i + 1}级的规格【${item.property_name}】里${errMsg}，请先修改`
				break
			}
		}
		else {
			if (findItem?.IsRequired) {
				msg = `第${i + 1}级的规格【${item.property_name}】里有规格值未填写，请先填写`
				break
			}
		}
	}
	if (msg) return msg
	const list = submitData.skuList
	const isNoPrice = list?.some(item => !item.price)
	if (isNoPrice) return 'SKU的价格是必填项'
}

// 整理最终要提交的sku参数
function FormatSubmitSkuData({ submitData, item }) {
	// Specs参数不需要传数据
	submitData.Specs = null
	// 提交前整理SKU列表
	setSkuList({ submitData, item })
	// 提交前整理主SKU图片
	setSkuImageMap({ submitData, item })
}

// 提交前整理SKU列表
function setSkuList({ submitData, item }) {
	submitData.SkuList = []
	for (let sku of item.skuList) {
		const obj = {
			// IsCanUse: true,
			// IsJxhy: true,
			OriginSkuId: sku.OriginSkuId || '',
			OriginPrice: +(sku.origin_price * 100).toFixed(2),
			OriginStock: sku.origin_stock,
			Price: +(sku.price * 100).toFixed(2),
			Stock: sku.stock_num,
			SellProperties: []
		}
		let skuName = ''
		const skuLen = sku.sell_properties.length
		for (let i = 0; i < skuLen; i++) {
			const op = sku.sell_properties[i]
			obj.SellProperties.push({ 
				ValueId: '',
				ValueName: op.value_name,
				PropId: op.PropId,
				PropName: op.property_name
			})
			skuName += `${op.value_name}${i + 1 === skuLen ? '' : '-'}`
		}
		obj.SkuName = obj.SkuSubTitle = skuName
		submitData.SkuList.push(obj)
	}
}

// 提交前整理主SKU图片
function setSkuImageMap({ submitData, item }) {
	submitData.SpecPicMap = {}
	const mainSkuObj = item.skuInfo?.[0]
	if (mainSkuObj?.images?.length && mainSkuObj.images.filter(item => item.img)?.length) {
		for (let i = 0; i < mainSkuObj.values.length; i++) {
			const sku = mainSkuObj.values[i]
			const img = mainSkuObj.images?.[i]?.img
			if (img) submitData.SpecPicMap[`${sku.property_name}-${sku.value_name}`] = img
		}
	}
}

export default {
	SetGoodsSkuInfo, CheckSubmitSkuData, FormatSubmitSkuData
}